import { defineStore } from 'pinia';
import { ref } from 'vue';

/**
 * Global visibility state for the Listing Audit "quota exceeded" upgrade modal.
 *
 * The modal is mounted once at the app root (App.vue) so it can be shown on top of
 * whatever screen the user is currently on, instead of navigating them into the
 * Listing Audit page, which would render blank behind the modal and dead-end on close.
 *
 * Opened from the `/listing-audit/:id` route guard when the member has no remaining
 * Listing Audit quota (see modules/listing-audit/routes.ts).
 */
export const useListingAuditQuotaModalStore = defineStore('listingAuditQuotaModal', () => {
  const visible = ref<boolean>(false);

  function open() {
    visible.value = true;
  }

  function close() {
    visible.value = false;
  }

  return { visible, open, close };
});
